import { render, staticRenderFns } from "./updateFlightPriceModal.vue?vue&type=template&id=5f2548a8&scoped=true&"
import script from "./updateFlightPriceModal.vue?vue&type=script&lang=ts&"
export * from "./updateFlightPriceModal.vue?vue&type=script&lang=ts&"
import style0 from "./updateFlightPriceModal.vue?vue&type=style&index=0&id=5f2548a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2548a8",
  null
  
)

export default component.exports